import t from '~t'
import React, { useEffect, useRef, useState, useCallback } from 'react'
import { target } from '~target'

import Text from '../text'
import { ShortDate } from '~modules/format/date'
import { Button, Text as Note, Icon } from '~ui';
import Color from './color'
import UserUpgrade from '~co/user/upgrade'

export default function HighlightsItemView({ text, color, created, pro, onScrollIntoView, onChange, onRemove, ...etc }) {
    const noteRef = useRef(null)

    const [needUpgrade, setNeedUpgrade] = useState(false)

    const [note, setNote] = useState(()=>etc.note)
    useEffect(()=>setNote(etc.note), [etc.note])

    const onChangeNote = useCallback(e=>setNote(e.target.value), [])
    const onSubmitNote = useCallback(e=>{
        e.preventDefault()
        onChange({ note })
    }, [note, onChange])
    const onClickNote = useCallback(e=>{
        if (pro) return
        e.preventDefault()
        setNeedUpgrade(true)
    }, [pro])

    const onFormMouseDown = useCallback(e=>{
        if (noteRef.current)
            if (e.target == e.currentTarget || e.target == noteRef.current)
                setTimeout(() => noteRef.current?.focus())
    }, [noteRef])

    return (
        <form 
            onSubmit={onSubmitNote} 
            onMouseDown={onFormMouseDown}
            onMouseLeave={target == 'extension' ? onSubmitNote : undefined}
            className={'ui-highlight-item'}>
            <Text 
                className={'ui-highlight-item-text'}
                color={color}
                data-clickable={typeof onScrollIntoView == 'function'}
                onClick={onScrollIntoView}>
                {text}
            </Text>

            <div className={'ui-highlight-footer'}>
                <div 
                    className={'ui-highlight-noteWrap'}
                    onClick={onClickNote}>
                    <Note 
                        ref={noteRef}
                        className={'ui-highlight-note'}
                        type='text'
                        variant='inline'
                        autoSize
                        multiline
                        autoComplete='off'
                        spellCheck='false'
                        disabled={!pro}
                        placeholder={t.s('addNote')+'…'}
                        value={note}
                        onChange={onChangeNote}
                        onBlur={onSubmitNote} />
                </div>

                <div className={'ui-highlight-buttons'}>
                    <Color 
                        color={color}
                        onChange={onChange} />

                    <Button 
                        variant='accent'
                        accent='danger'
                        title={t.s('removeHighlights')}
                        onClick={onRemove}>
                        <Icon name='trash' />
                    </Button>

                    <div className={'ui-highlight-created'}>
                        <ShortDate date={created} />
                    </div>
                </div>
            </div>

            {needUpgrade ? <UserUpgrade onClose={()=>setNeedUpgrade(false)} /> : null}
        </form>
    )
}